<template>
    <print-container>
        <div v-for="(saison, i) in saisonenWithRanking" :key="i"
             :class="[{'pageBreak': i%2 !== 0 }, 'py-0']" style="width: 100%">
            <div class="text-center title mt-7 mb-2" v-if="i%2 === 0">{{header}}</div>
            <div class="subtitle-1 px-3 pb-2 my-0 font-weight-medium">{{saison.local.title}}</div>
            <tabelle :saison="saison" :hide-legend="true" :dense="true" :is-print="true"
                     :class="[{'mb-8': $vuetify.breakpoint.smAndDown},
                         {'mb-4': $vuetify.breakpoint.mdAndUp}]">
            </tabelle>
        </div>
    </print-container>
</template>

<script>
    import Tabelle from "../tabelle";
    import PrintContainer from "./printContainer";

    export default {
        components: {
            PrintContainer,
            Tabelle},
        name: "print-tabellen",
        computed: {
            header(){return this.$store.state.local.printContainer.header},
            saisonenWithRanking(){return this.$store.state.local.printContainer.content},
        },
    }
</script>

<style scoped>
</style>